import type { ReactNode } from "react";

import { Keys } from "../shortcuts/Keys";
import { editingGuide, type GuideSection } from "./guide";

function Input({ section, value }: { section: GuideSection; value: string }): ReactNode {
  if (section.kind === "keys") return <Keys keys={value} />;
  return (
    <code className="rounded border border-line bg-surface px-1.5 py-0.5 font-mono text-xs text-ink">
      {value}
    </code>
  );
}

/** The short editing guide: what to type, what to press, what happens. */
export function EditingGuide(): ReactNode {
  return (
    <div className="max-h-[60vh] overflow-y-auto pr-1">
      {editingGuide().map((section) => (
        <section key={section.title} className="mb-5">
          <h3 className="mb-1 text-xs font-semibold tracking-wide text-muted uppercase">
            {section.title}
          </h3>
          {section.intro !== "" && <p className="mb-2 text-sm text-ink">{section.intro}</p>}
          {section.rows.length > 0 && (
            <table className="w-full border-collapse text-sm">
              <tbody>
                {section.rows.map((row) => (
                  <tr key={row.input} className="align-top">
                    <th scope="row" className="w-2/5 py-1 pr-4 text-left font-normal">
                      <Input section={section} value={row.input} />
                    </th>
                    <td className="py-1 text-ink">{row.result}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      ))}
    </div>
  );
}
